<template>
  <div class="apartment-page" @mouseleave="$root.showMascot($event)">
    <div v-if="apartment" class="apartment-page__wrapper">
      <page-header
        dark-crumb
        inline
        class="apartment-page__header"
        :title="apartmentName"
        :link-to="{ name: 'FilterPage' }"
      >
        <div v-if="false" class="apartment-page__header-checks">
          <check-tag class="apartment-page__header-check">
            Вид на дорогу
          </check-tag>
          <check-tag class="apartment-page__header-check">
            Потолки 3,3 м
          </check-tag>
          <check-tag class="apartment-page__header-check">
            Цена до 22.03
          </check-tag>
        </div>
      </page-header>

      <content-wrapper-block class="apartment-page__detail apart-detail">
        <div class="apart-detail__content">
          <ui-tab-bar v-model="tabs.current" class="apart-detail__tabs">
            <ui-tab-bar-tab
              v-for="(tab, index) in tabs.options"
              :key="index"
              class="apart-detail__tab"
              :value="tab"
            >
              {{ tab }}
            </ui-tab-bar-tab>
          </ui-tab-bar>
          <div
            v-show="tabs.current === 'Планировка'"
            class="apart-detail__tab-content"
          >
            <div class="apart-detail__plan">
              <picture v-show="layoutSelected === 0" :key="-1">
                <source
                  :srcset="apartment.layout.plan_image.source"
                  media="(min-width: 1200px)"
                />
                <img
                  class="apart-detail__plan-image"
                  :src="apartment.layout.plan_image.image_thumb"
                />
              </picture>
              <picture
                v-for="(plan, index) in alternative"
                v-show="layoutSelected === index + 1"
                :key="index"
              >
                <img
                  :src="plan.image.image_desktop"
                  class="apart-detail__plan-image"
                />
              </picture>
              <div v-if="apartment.discount && apartment.properties?.give_meters" class="apart-detail__plan-promo">
                {{ helpers.getDiscountArea(apartment) }} м²
                <small>в подарок!</small>
              </div>
              <ui-button-small
                class="apart-detail__fullscreen"
                @click="showModal"
              >
                <icon-fullscreen />
              </ui-button-small>
            </div>
            <div v-if="alternative" class="apart-detail__title">
              <img
                src="@/assets/images/icons/plans.svg"
                class="apart-container__type-icon"
              />
              Возможные планировки
            </div>
            <div v-if="alternative" class="apart-detail__alternative">
              <card-apartment-plan
                class="apart-detail__alternative-item"
                :selected="layoutSelected === 0"
                :image-jpg="getPlanImage(apartment, 'png')"
                subtitle="Основная"
                @click="layoutSelected = 0"
              />
              <card-apartment-plan
                v-for="(plan, index) in alternative"
                :key="index"
                class="apart-detail__alternative-item"
                :selected="index + 1 === layoutSelected"
                :image-jpg="plan.image.image_thumb"
                :subtitle="'Возможность ' + (index + 1)"
                @click="layoutSelected = index + 1"
              />
            </div>
          </div>
          <div
            v-show="tabs.current === 'Этаж'"
            class="apart-detail__tab-content-dls"
          >
            <div class="apart-detail__plan-poligon">
              <street-compass-wrapper :korpus="apartment.korpus">
                <floor-plan-zoom-poligon
                  v-show="apartment.floor_image.image_thumb"
                  :zoom="false"
                  :src="apartment.floor_image.image_thumb"
                  :polygons="polygons"
                  :width="apartment.floor_image.width"
                  :height="apartment.floor_image.height"
                  @polygonClick="onPolygonClick"
                />
              </street-compass-wrapper>
              <ui-button-small
                class="apart-detail__fullscreen"
                @click="showModal"
              >
                <icon-fullscreen />
              </ui-button-small>
            </div>
          </div>
          <div
            v-show="tabs.current === 'Генплан'"
            class="apart-detail__tab-content-dls"
          >
            <div class="apart-detail__plan-poligon">
              <gen-plan v-if="apartment.section" :section="apartment.section" />
              <ui-button-small
                class="apart-detail__fullscreen"
                @click="showModal"
              >
                <icon-fullscreen />
              </ui-button-small>
            </div>
          </div>

          <div
            v-if="apartment.properties._gallery"
            v-show="tabs.current === 'Фотографии отделки'"
            class="apart-detail__tab-content"
          >
            <div class="apart-detail__gallery">
              <apartment-gallery
                :slides="apartment.properties._gallery"
                gallery-title="Все фотографии"
                showNav
              />
            </div>
          </div>
        </div>
        <div class="apart-detail__info apart-info">
          <div class="apart-info__areas">
            <div class="apart-info__areas-title">
              ПЛОЩАДЬ ПОМЕЩЕНИЙ, {{ area }} М²
            </div>
            <div class="apart-info__areas-list apart-areas">
              <ol class="apart-areas__list">
                <li
                  v-for="(roomarea, areaindex) in roomItems"
                  v-show="apartment.areas"
                  :key="areaindex"
                  class="apart-areas__list-item area-item"
                >
                  <span class="area-item__number">{{ roomarea.number }}</span>
                  <span class="area-item__body">
                    <span class="area-item__key">{{ roomarea.name }}</span
                    ><span class="area-item__value"
                      >{{ roomarea.area }} м²</span
                    >
                  </span>
                </li>
                <span
                  v-if="page < numPages"
                  class="items__shown"
                  @click="next(+1)"
                  >Показать все</span
                >
                <span
                  v-if="page >= numPages"
                  class="items__shown"
                  @click="next(-1)"
                  >Cкрыть</span
                >
              </ol>
            </div>

            <div v-if="alternative" class="apart-detail__description">
              <div class="apart-detail__description-top">
                <div class="">
                  особенности планировки |
                  <span>{{ apartment.plan_type }}</span>
                </div>
                <div class="items">
                  <span v-if="shownBtn" class="items__shown" @click="clickShown"
                    >Узнать</span
                  >
                  <span v-if="closeBtn" class="items__shown" @click="clickClose"
                    >Cкрыть</span
                  >
                </div>
              </div>
              <div v-if="descr" class="">
                <div
                  v-for="(desc, index) in description"
                  :key="index"
                  class="apart-detail__description-items"
                  v-html="desc"
                />
              </div>
            </div>
          </div>
          <div
            class="apart-info__props apart-props"
            style="padding: 0; border-bottom: none"
          >
            <div v-if="hasDecoration" class="apart-props__item">
              <div class="apart-props__item-label">
                <img
                  class="apart-props__item-icon"
                  src="@/assets/images/icons/decoration_dark.svg"
                  alt=""
                />Отделка
              </div>
              <div class="apart-props__item-value">
                <template v-if="apartment.properties.with_decoration_furnished">
                  С отделкой<br>и мебелью**
                </template>
                <template v-else-if="apartment.properties.with_decoration_finishing">
                  Чистовая
                </template>
                <template v-else-if="apartment.properties.with_decoration_design">
                  Дизайнерская
                </template>
                <template v-else-if="apartment.properties.with_decoration_whitebox">
                  Предчистовая отделка
                </template>
                <template v-else>
                  На выбор
                <div class="apart-props__item-value--small">
                  <span>x</span>4 варианта
                </div>
                </template>
              </div>
            </div>
            <div class="apart-props__item">
              <div class="apart-props__item-label">Секция</div>
              <div class="apart-props__item-value">
                {{ apartment.section }}
              </div>
            </div>
            <div class="apart-props__item">
              <div class="apart-props__item-label">Этаж</div>
              <div class="apart-props__item-value">
                {{ apartment.floor }}
              </div>
            </div>
            <div class="apart-props__item">
              <div class="apart-props__item-label">№ на площадке</div>
              <div class="apart-props__item-value">
                {{ apartment.number_on_floor }}
              </div>
            </div>
            <div
              v-if="!hasDecoration"
              class="apart-props__item"
            >
              <div class="apart-props__item-label">№ апартамента:&nbsp;</div>
              <div class="apart-props__item-value">
                {{ apartment.number }}
              </div>
            </div>
          </div>
          <div class="apart-info__border" />

          <div class="apart-info__cost">
            <div class="apart-info__cost-wrapper">
              <span class="apart-info__cost-now_min"
                >{{ parseInt(apartment.discount ? apartment.discount_cost : apartment.amount).toLocaleString("ru") }} ₽</span
              >
              <span
                v-if="apartment.discount || apartment.properties.old_cost"
                class="apart-info__cost-old">
                {{ parseInt(apartment.properties.old_cost || apartment.amount).toLocaleString("ru") }} ₽
              </span>
              <template v-if="apartment.properties.cost_footnote">**</template>
            </div>
            <span
              v-if="storage.mortgage && apartment.status !== 'Уступка от физлица'"
              class="apart-info__cost-now"
              >или от
              {{
                setMortgagePay({ ...apartment, cost: apartment.cost ?? apartment.amount }, storage.mortgage)
              }}
              ₽/мес<b v-if="storage.mortgage.footnote" style="font-weight: 300">*</b></span
            >
            <span v-if="apartment.properties.mortgage_percent" class="apart-info__special-mortgage">
              Особенные условия по ипотеке - минус&nbsp;{{apartment.properties.mortgage_percent}}%
            </span>
          </div>
          <div
            class="apart-info__bottom"
            :class="{
              'apart-info__bottom--column':
                apartment.status === 'Уступка от физлица',
            }"
          >
            <div class="apart-info__bottom-buttons">
              <ui-button
                v-if="apartment.status === 'Свободен'"
                id="button-apartment__booking"
                class="apart-info__bottom-act1"
                data-popup-with-chats
                :data-popup-with-chats-title="
                  'Узнать подробнее про №' + apartment.number
                "
              >
                Узнать подробнее
              </ui-button>
              <div
                v-if="apartment.status === 'Свободен'"
                class="apart-info__bottom-button-group apart-info__bottom-button-group--tradein"
              >
                <div>
                  <ui-button
                    data-popup-with-chats
                    data-popup-with-chats-title="Trade In"
                    class="apart-info__bottom-act2" outline>
                    Trade-In
                  </ui-button>
                </div>
                <div class="apart-info__bottom-share">
                  <ui-button
                    outline
                    class="apart-info__bottom-share-act2"
                    @click="openShare"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                    >
                      <path
                        d="M15.175 20C14.3917 20 13.7208 19.7208 13.1625 19.1625C12.6042 18.6042 12.325 17.9333 12.325 17.15C12.325 17.0333 12.3375 16.8958 12.3625 16.7375C12.3875 16.5792 12.425 16.4333 12.475 16.3L4.9 11.9C4.65 12.1833 4.34167 12.4125 3.975 12.5875C3.60833 12.7625 3.23333 12.85 2.85 12.85C2.06667 12.85 1.39583 12.5708 0.8375 12.0125C0.279167 11.4542 0 10.7833 0 10C0 9.2 0.279167 8.525 0.8375 7.975C1.39583 7.425 2.06667 7.15 2.85 7.15C3.23333 7.15 3.6 7.225 3.95 7.375C4.3 7.525 4.61667 7.74167 4.9 8.025L12.475 3.675C12.425 3.55833 12.3875 3.425 12.3625 3.275C12.3375 3.125 12.325 2.98333 12.325 2.85C12.325 2.05 12.6042 1.375 13.1625 0.825C13.7208 0.275 14.3917 0 15.175 0C15.975 0 16.65 0.275 17.2 0.825C17.75 1.375 18.025 2.05 18.025 2.85C18.025 3.63333 17.75 4.30417 17.2 4.8625C16.65 5.42083 15.975 5.7 15.175 5.7C14.7917 5.7 14.4208 5.6375 14.0625 5.5125C13.7042 5.3875 13.4 5.18333 13.15 4.9L5.575 9.1C5.60833 9.23333 5.6375 9.3875 5.6625 9.5625C5.6875 9.7375 5.7 9.88333 5.7 10C5.7 10.1167 5.6875 10.2417 5.6625 10.375C5.6375 10.5083 5.60833 10.6417 5.575 10.775L13.15 15.075C13.4 14.8417 13.6917 14.6542 14.025 14.5125C14.3583 14.3708 14.7417 14.3 15.175 14.3C15.975 14.3 16.65 14.575 17.2 15.125C17.75 15.675 18.025 16.35 18.025 17.15C18.025 17.9333 17.75 18.6042 17.2 19.1625C16.65 19.7208 15.975 20 15.175 20ZM15.175 4.2C15.5583 4.2 15.8792 4.07083 16.1375 3.8125C16.3958 3.55417 16.525 3.23333 16.525 2.85C16.525 2.46667 16.3958 2.14583 16.1375 1.8875C15.8792 1.62917 15.5583 1.5 15.175 1.5C14.7917 1.5 14.4708 1.62917 14.2125 1.8875C13.9542 2.14583 13.825 2.46667 13.825 2.85C13.825 3.23333 13.9542 3.55417 14.2125 3.8125C14.4708 4.07083 14.7917 4.2 15.175 4.2V4.2ZM2.85 11.35C3.23333 11.35 3.55417 11.2208 3.8125 10.9625C4.07083 10.7042 4.2 10.3833 4.2 10C4.2 9.61667 4.07083 9.29583 3.8125 9.0375C3.55417 8.77917 3.23333 8.65 2.85 8.65C2.46667 8.65 2.14583 8.77917 1.8875 9.0375C1.62917 9.29583 1.5 9.61667 1.5 10C1.5 10.3833 1.62917 10.7042 1.8875 10.9625C2.14583 11.2208 2.46667 11.35 2.85 11.35V11.35ZM15.175 18.5C15.5583 18.5 15.8792 18.3708 16.1375 18.1125C16.3958 17.8542 16.525 17.5333 16.525 17.15C16.525 16.7667 16.3958 16.4458 16.1375 16.1875C15.8792 15.9292 15.5583 15.8 15.175 15.8C14.7917 15.8 14.4708 15.9292 14.2125 16.1875C13.9542 16.4458 13.825 16.7667 13.825 17.15C13.825 17.5333 13.9542 17.8542 14.2125 18.1125C14.4708 18.3708 14.7917 18.5 15.175 18.5Z"
                        fill="#E14313"
                      />
                    </svg>
                  </ui-button>
                  <div
                    id="yaShare"
                    class="apart-info__bottom-share-container"
                    :class="{ openned: shareOpenned }"
                  />
                </div>
              </div>
              <div
                v-if="apartment.status === 'Забронировано'"
                class="apart-info__bottom-booked"
              >
                апартамент уже забронирован
              </div>
              <template v-if="apartment.status === 'Уступка от физлица'">
                <div class="apart-info__bottom-booked">Уступка от физлица</div>
                <div class="apart-info__bottom-button-group">
                  <ui-button
                    class="apart-info__bottom-act2"
                    outline
                    data-popup-with-chats
                    data-popup-with-chats-title="Консультация"
                  >
                    Консультация
                  </ui-button>

                  <div class="apart-info__bottom-share">
                    <ui-button
                      outline
                      class="apart-info__bottom-share-act2"
                      @click="openShare"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                      >
                        <path
                          d="M15.175 20C14.3917 20 13.7208 19.7208 13.1625 19.1625C12.6042 18.6042 12.325 17.9333 12.325 17.15C12.325 17.0333 12.3375 16.8958 12.3625 16.7375C12.3875 16.5792 12.425 16.4333 12.475 16.3L4.9 11.9C4.65 12.1833 4.34167 12.4125 3.975 12.5875C3.60833 12.7625 3.23333 12.85 2.85 12.85C2.06667 12.85 1.39583 12.5708 0.8375 12.0125C0.279167 11.4542 0 10.7833 0 10C0 9.2 0.279167 8.525 0.8375 7.975C1.39583 7.425 2.06667 7.15 2.85 7.15C3.23333 7.15 3.6 7.225 3.95 7.375C4.3 7.525 4.61667 7.74167 4.9 8.025L12.475 3.675C12.425 3.55833 12.3875 3.425 12.3625 3.275C12.3375 3.125 12.325 2.98333 12.325 2.85C12.325 2.05 12.6042 1.375 13.1625 0.825C13.7208 0.275 14.3917 0 15.175 0C15.975 0 16.65 0.275 17.2 0.825C17.75 1.375 18.025 2.05 18.025 2.85C18.025 3.63333 17.75 4.30417 17.2 4.8625C16.65 5.42083 15.975 5.7 15.175 5.7C14.7917 5.7 14.4208 5.6375 14.0625 5.5125C13.7042 5.3875 13.4 5.18333 13.15 4.9L5.575 9.1C5.60833 9.23333 5.6375 9.3875 5.6625 9.5625C5.6875 9.7375 5.7 9.88333 5.7 10C5.7 10.1167 5.6875 10.2417 5.6625 10.375C5.6375 10.5083 5.60833 10.6417 5.575 10.775L13.15 15.075C13.4 14.8417 13.6917 14.6542 14.025 14.5125C14.3583 14.3708 14.7417 14.3 15.175 14.3C15.975 14.3 16.65 14.575 17.2 15.125C17.75 15.675 18.025 16.35 18.025 17.15C18.025 17.9333 17.75 18.6042 17.2 19.1625C16.65 19.7208 15.975 20 15.175 20ZM15.175 4.2C15.5583 4.2 15.8792 4.07083 16.1375 3.8125C16.3958 3.55417 16.525 3.23333 16.525 2.85C16.525 2.46667 16.3958 2.14583 16.1375 1.8875C15.8792 1.62917 15.5583 1.5 15.175 1.5C14.7917 1.5 14.4708 1.62917 14.2125 1.8875C13.9542 2.14583 13.825 2.46667 13.825 2.85C13.825 3.23333 13.9542 3.55417 14.2125 3.8125C14.4708 4.07083 14.7917 4.2 15.175 4.2V4.2ZM2.85 11.35C3.23333 11.35 3.55417 11.2208 3.8125 10.9625C4.07083 10.7042 4.2 10.3833 4.2 10C4.2 9.61667 4.07083 9.29583 3.8125 9.0375C3.55417 8.77917 3.23333 8.65 2.85 8.65C2.46667 8.65 2.14583 8.77917 1.8875 9.0375C1.62917 9.29583 1.5 9.61667 1.5 10C1.5 10.3833 1.62917 10.7042 1.8875 10.9625C2.14583 11.2208 2.46667 11.35 2.85 11.35V11.35ZM15.175 18.5C15.5583 18.5 15.8792 18.3708 16.1375 18.1125C16.3958 17.8542 16.525 17.5333 16.525 17.15C16.525 16.7667 16.3958 16.4458 16.1375 16.1875C15.8792 15.9292 15.5583 15.8 15.175 15.8C14.7917 15.8 14.4708 15.9292 14.2125 16.1875C13.9542 16.4458 13.825 16.7667 13.825 17.15C13.825 17.5333 13.9542 17.8542 14.2125 18.1125C14.4708 18.3708 14.7917 18.5 15.175 18.5Z"
                          fill="#E14313"
                        />
                      </svg>
                    </ui-button>
                    <div
                      id="yaShare"
                      class="apart-info__bottom-share-container"
                      :class="{ openned: shareOpenned }"
                    />
                  </div>
                </div>
              </template>
            </div>
            <div v-if="false" class="apart-info__bottom-action">
              <ui-button-gray>
                <icon-star />
              </ui-button-gray>
              <ui-button-gray>
                <icon-printer />
              </ui-button-gray>
              <ui-button-gray>
                <icon-share />
              </ui-button-gray>
            </div>
          </div>
          <div class="apart-info__border" />
          <span
            v-if="apartment.status !== 'Уступка от физлица'"
            class="apart-info__description"
          >
            <p class="apart-info__footnote" v-html="storage.mortgage.footnote"></p>
            <template v-if="apartment.properties.with_decoration_furnished">
              <br>
              **Декор и часть мебели не входят в стоимость апартаментов
            </template>
            <template v-if="apartment.properties.has_decoration">
              <br>
              ** Отделка включена в стоимость
            </template>
            <p v-if="apartment.properties.cost_footnote" v-html="apartment.properties.cost_footnote" />
          </span>
        </div>
      </content-wrapper-block>
      <FlatGallery v-if="gallerySlides[apartment.id]" :slides="gallerySlides[apartment.id]" />
      <!-- <features-block /> -->
      <callback-block
        v-if="false"
        theme="black"
        title="Ваш дизайн-проект - в подарок!"
        subtitle="При покупке до 20.07.2020"
        :image="require('../assets/images/forms/form-block-right.png')"
      />
      <mortgage-block v-if="apartment.status !== 'Уступка от физлица'" />
      <specials-block v-if="false" />
      <best-apartments-block />
      <contacts-block
        :building-address="address"
        :ofiice-address="office"
        building-work-time="<p>Пн-Пт с 09:00 до 21:00 <br> Сб-Вс с 10:00 до 20:00</p>"
        office-work-time="<p>Пн-Пт с 09:00 до 21:00 <br> Сб-Вс с 10:00 до 20:00</p>"
      />
      <callback-block id="callback" id-formblock="question-block__callback" />
      <modal-plans
        v-show="isModalVisible"
        ref="test"
        :apartment="apartment"
        :apartment-number="apartment.number"
        :slide-index="layoutSelected"
        :visible="visible"
        :alternative="alternative"
        :layout-selected="layoutSelected"
        :src="imgSwitch"
        :dls-plans="dlsSwitch"
        :title="titleSwitch"
        :polygons="polygons"
        @polygonClick="onPolygonClick"
        @close="closeModal"
      />
    </div>
  </div>
</template>

<script>
import yaShare from "@/plugins/yaShare.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import { helpers } from "@osnova-adv/ms3-blocks";
import axios from "axios";

import {
  apartmentGallery,
  individualGallery,
} from "@/content";
import PageHeader from "@/components/elements/PageHeader";
import CheckTag from "@/components/elements/CheckTag";
import ContentWrapperBlock from "@/components/blocks/ContentWrapperBlock";
import UiButtonSmall from "@/components/ui/UIButtonSmall";
import IconFullscreen from "@/components/icons/IconFullscreen";
import UiButton from "@/components/ui/UIButton";
import UiButtonGray from "@/components/ui/UIButtonGray";
import IconStar from "@/components/icons/IconStar";
import IconPrinter from "@/components/icons/IconPrinter";
import IconShare from "@/components/icons/IconShare";
import MortgageBlock from "@/components/blocks/MortgageBlock";
import CallbackBlock from "@/components/blocks/CallbackBlock";
import SpecialsBlock from "@/components/blocks/SpecialsBlock";
import BestApartmentsBlock from "@/components/blocks/BestApartmentsBlock";
import ContactsBlock from "@/components/blocks/ContactsBlock";
import ModalPlans from "@/components/dialogs/ModalPlansApartmens";
import CardApartmentPlan from "@/components/elements/CardApartmentPlan";
import UiTabBar from "@/components/ui/UITabBar";
import UiTabBarTab from "@/components/ui/UITabBarTab";
import FloorPlanZoomPoligon from "@/components/elements/FloorPlanZoomPoligon";
import StreetCompassWrapper from "@/components/elements/StreetCompassWrapper";
import genPlan from "@/components/elements/GenPlan";
import ApartmentGallery from "@/components/blocks/ApartmentGallery.vue";
import FlatGallery from '@/components/blocks/FlatGallery';
import { viewProduct } from "@/mindbox";

export default {
  name: "ApartmentPage",
  components: {
    BestApartmentsBlock,
    SpecialsBlock,
    MortgageBlock,
    CallbackBlock,
    IconShare,
    IconPrinter,
    IconStar,
    UiButtonGray,
    UiButton,
    // IconEye,
    IconFullscreen,
    UiButtonSmall,
    ContentWrapperBlock,
    CheckTag,
    PageHeader,
    ContactsBlock,
    ModalPlans,
    CardApartmentPlan,
    UiTabBar,
    UiTabBarTab,
    FloorPlanZoomPoligon,
    genPlan,
    StreetCompassWrapper,
    ApartmentGallery,
    FlatGallery
  },
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Купить просторные апартаменты в новостройке на Кутузовском проспекте.",
      },
    ],
  },
  data: () => {
    return {
      helpers,
      apartment: null,
      areasOpen: false,
      isModalVisible: false,
      page: 1,
      perPage: 4,
      visible: false,
      layoutSelected: 0,
      descr: true,
      closeBtn: true,
      adapterApartList: [],
      shownBtn: false,
      shareOpenned: false,
      shareInited: false,
      tabs: {
        current: "",
        options: ["Планировка", "Этаж", "Генплан"],
      },
      gallerySlides: {
        'd6dcc7c8-bec9-4afb-bd0d-3dcfeef0eefe': [
          require('@/assets/images/apartment/gallery/А1.26.293/IMG_2456.jpeg'),
          require('@/assets/images/apartment/gallery/А1.26.293/IMG_2458.jpeg'),
          require('@/assets/images/apartment/gallery/А1.26.293/IMG_2460.jpeg'),
          require('@/assets/images/apartment/gallery/А1.26.293/IMG_6728.jpeg'),
          require('@/assets/images/apartment/gallery/А1.26.293/IMG_6730.jpeg'),
          require('@/assets/images/apartment/gallery/А1.26.293/IMG_6736.jpeg'),
          require('@/assets/images/apartment/gallery/А1.26.293/IMG_6737.jpeg')
        ]
      }
    };
  },
  watch: {
    apartment() {
      setTimeout(() => {
        this.initShare();
      }, 900);
    },
    $route: {
      deep: true,
      handler () {
        if (this.$route.name === 'ApartmentPage') {
          this.loadApartment(this.$route.params.id);
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      layouts: "layouts",
      mortgageProps: "GET_MORTGAGE_PROPS"
    }),
    ...mapState({
      minPercent: (state) => state.minPercent,
      apartments: (state) => state.apartments,
      storage: (state) => state.storage,
    }),
    address () {
      if (!this.storage || !this.storage.addresses) {
        return ''
      }
      return '<p class="marginss">' + this.storage.addresses.addr_list[0].addr_location + '</p>'
    },
    office () {
      if (!this.storage || !this.storage.addresses) {
        return ''
      }
      return '<p>' + this.storage.addresses.addr_list[1].addr_location + '</p>'
    },
    imgSwitch() {
      if (this.apartment) {
        if (this.tabs.current === "Этаж") {
          return this.apartment.floor_image.source;
        } else if (this.tabs.current === "Генплан") {
          return require("@/assets/images/apartment/plan.png");
        }
          return this.apartment.layout.plan_image.source;
      }
      return "";
    },
    dlsSwitch() {
      if (this.tabs.current === "Планировка") {
        return true;
      }
      return false;
    },
    titleSwitch() {
      if (this.tabs.current === "Этаж") {
        return "План этажа";
      } else if (this.tabs.current === "Генплан") {
        return "Генеральный план";
      }
      return this.apartmentName;
    },
    alternative() {
      return this.layouts[this.apartment.number];
    },
    description() {
      if (this.layoutSelected > 0) {
        return this.alternative[this.layoutSelected - 1].description;
      }
      return this.apartment.description.split("\n");
    },
    hasDecoration() {
      const { properties } = this.apartment ?? {};
      return (
        properties.with_decoration ||
        properties.with_decoration_furnished ||
        properties.with_decoration_finishing ||
        properties.with_decoration_whitebox
      );
    },
    countItems() {
      return this.apartment.areas;
    },
    apartmentName() {
      const room = this.formatQuantity(this.apartment.quantity);
      let out = `${room} ${this.apartment.area}, м²`;
      return out;
    },
    area() {
      return `${this.apartment.area}`;
    },
    roomItems() {
      if (window.innerWidth <= 640) {
        return this.apartment.areas.slice(0, this.page * this.perPage);
      } else {
        return this.apartment.areas;
      }
    },
    numPages() {
      return Math.ceil(this.countItems / this.perPage);
    },
    polygons() {
      return this.apartments.filter((apartment) =>
        apartment.korpus == this.apartment.korpus &&
        apartment.section == this.apartment.section &&
        apartment.floor == this.apartment.floor
      ).map((apartment) => ({
        id: apartment.id,
        points: apartment.area_points,
        active: apartment.id === this.apartment.id
      }));
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadApartment(vm.$route.params.id);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.setMascotFlag(false);
    next();
  },
  created() {
    // this.$loadTrackScript();
  },
  deactivated() {
    this.apartment = null;
  },
  handler() {
    this.getAdapterApartList();
  },
  methods: {
    ...mapMutations({
      setBreadcrumb: "SET_BREADCRUMB",
      setApartments: "SET_APARTMENTS",
      setMascotFlag: "SET_MASCOT_FLAG",
    }),
    setMortgagePay (apartment, mortgage) {
      return helpers.setMortgagePay(apartment, mortgage).toLocaleString("ru")
    },
    openShare() {
      this.shareOpenned = !this.shareOpenned;
    },
    initShare() {
      if (this.apartment) {
        if (!this.shareInited) {
          this.$nextTick(() => {
            yaShare(
              "yaShare",
              "Квартира №" +
                this.apartment.number +
                " в квартале Mainstreet от ГК ОСНОВА",
              window.location.href,
              ""
            );
            this.shareInited = true;
          });
        }
      } else {
        this.shareInited = false;
      }
    },
    next(change) {
      if (change === -1) {
        this.page = 1;
      } else {
        this.page = 100;
      }
    },
    clickClose() {
      this.$emit("click");
      this.descr = false;
      this.closeBtn = false;
      this.shownBtn = true;
    },
    clickShown() {
      this.$emit("click");
      this.descr = true;
      this.closeBtn = true;
      this.shownBtn = false;
    },
    loadApartment(id) {
      this.$route.meta.breadcrumb = "";
      // this.setLoading(true)
      this.layoutSelected = 0;
      axios
        .get(this.apartmentsApi + "property/" + id)
        .then(({ data }) => {
          viewProduct(data.data?.uuid);
          this.apartment = this.getAdapterApartList(data.data);
          this.tabs.options = this.tabs.options.filter(e => e != 'Фотографии отделки');

          if (this.apartment.properties.with_decoration_design) {
            this.apartment.properties._gallery = apartmentGallery.design;
          } else if (this.apartment.properties.with_decoration_whitebox) {
            this.apartment.properties._gallery = apartmentGallery.whitebox;
          }

          if(individualGallery && typeof individualGallery === 'object'){
            for(let code in individualGallery) {
              if(this.apartment.layout.code && this.apartment.layout.code == code) {
                this.apartment.properties._gallery = individualGallery[code];
              }
            }
          }

          if (this.apartment.properties._gallery) {
            this.tabs.options.push('Фотографии отделки');
          }
          this.setBreadcrumb(this.apartmentName);
          this.initTabs();
          this.setMascotFlag(true);
          this.$setMeta({
            title: `${this.formatQuantity(this.apartment.quantity)} ${
              this.apartment.area
            } м², этаж ${this.apartment.floor} в квартале MAINSTREET`,
          });
        })
        .catch(() => this.$router.push("/"));
    },
    showModal() {
      setTimeout(() => {
        this.isModalVisible = true;
        this.visible = true;
      }, 0);
      setTimeout(() => {
        if (
          this.titleSwitch !== "Генеральный план" &&
          this.titleSwitch !== "План этажа"
        ) {
          this.$refs.test.$refs.swiper.$swiper.slideTo(this.layoutSelected);
        }
      }, 0);
    },
    closeModal() {
      this.visible = false;
    },
    getAdapterApartList(dataApart) {
      const associativeValues = {
        S: "Студия",
        E1: "Евро-1",
        E2: "Евро-2",
        E3: "Евро-3",
        E4: "Евро-4",
        E5: "Евро-5",
        1: "Однокомнатная",
        2: "Двухкомнатная",
        3: "Трехкомнатная",
        4: "Четырехкомнатная",
        5: "Пятикомнатная",
        available: "Свободен",
        available_agent: "Уступка от физлица",
        booked: "Забронировано",
      };

      if (dataApart.layout.variants.length) {
        dataApart.layout.variants[0].rooms.sort(function (a, b) {
          if (a.number > b.number) {
            return 1;
          }
          if (a.number < b.number) {
            return -1;
          }
          // a должно быть равным b
          return 0;
        });
      }

      return {
        id: dataApart.uuid,
        korpus: dataApart.building,
        section: dataApart.section,
        floor: String(dataApart.floor.number),
        type: dataApart.layout.type,
        number_on_floor: String(dataApart.number_on_floor),
        number: dataApart.number,
        quantity:
          associativeValues[dataApart.layout.room_count] !== undefined
            ? associativeValues[dataApart.layout.room_count]
            : dataApart.layout.room_count,
        area: dataApart.layout.area,
        amount: dataApart.cost,
        discount: dataApart.discount,
        discount_cost: dataApart.discount_cost,
        status:
          associativeValues[dataApart.status] !== undefined
            ? associativeValues[dataApart.status]
            : dataApart.status,
        layouttype: dataApart.layout.code,
        layout: dataApart.layout,
        floor_image: dataApart.floor.plan_image,
        plan_image: dataApart.layout.plan_image,
        plan_type: dataApart.properties.plan_type,
        areas: !dataApart.layout.variants.length
          ? []
          : dataApart.layout.variants[0].rooms,
        description: dataApart.properties.description,
        area_points: dataApart.area_points,
        properties: dataApart.properties,
      };
    },
    initTabs() {
      this.tabs.current = this.tabs.options[0];
    },
    onPolygonClick(e, { id }) {
      e.stopPropagation();
      const { korpus, section, floor, number_on_floor, number, quantity } =
        this.apartments.find((apartment) => apartment.id === id);
      this.$router.push({
        params: {
          id,
          korp: korpus,
          sec: section,
          floor: floor,
          fnumb: number_on_floor,
          numb: number,
          quantity: this.getQuantity(quantity)
        }
      });
    }
  },
};
</script>

<style lang="scss">
.apartment-page {
  &__header,
  .page-header {
    background-color: #f4f4f4;
    color: #231f20;
    border-bottom: 1px solid #18181b;
    padding-bottom: 0;

    &__block {
      display: flex;
      flex-direction: column;

      @media screen and (min-width: $screen-lg) {
        flex-direction: row;
      }
    }

    &__bottom {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      @media screen and (min-width: $screen-lg) {
        justify-content: flex-end;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.apartment-page {
  min-height: 100vh;
  background-color: #f4f4f4;
  color: #18181b;
  ::v-deep {
    .apartment-page__promo {
      margin-left: 3px;
      color: #ff5722;
      display: inline-block;
    }
  }

  &__header {
    background-color: #f4f4f4;
    color: #18181b;

    &-checks {
      color: #18181b;
    }

    &-check {
      padding-right: 15px;
    }
  }
  &__detail,
  .apart-detail {
    background-color: #f4f4f4;
    padding-top: 6px;
    display: flex;
    flex-direction: column;
    @media (min-width: $screen-sm) {
      padding-top: 36px;
    }

    &__title {
      display: flex;
      align-items: center;
      margin: 24px 0;

      img {
        margin-right: 5px;
      }
    }
    &__tab-content-dls {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__description {
      position: relative;
      color: #868687;
      border-bottom: 1px solid #00000011;
      margin-bottom: 20px;
      padding-bottom: 20px;
      font-size: 14px;
      font-weight: 300;

      &-top {
        display: flex;
        justify-content: space-between;
        letter-spacing: 0.18em;
        margin-bottom: 18px;

        span {
          font-weight: 500;
          color: #18181b;
        }

        .items {
          position: absolute;
          bottom: 5px;

          @media screen and (min-width: $screen-sm) {
            position: inherit;
          }

          &__shown {
            color: #18181b;
            font-weight: 300;
            text-decoration: underline;
            cursor: pointer;

            &:hover {
              text-decoration: none;
            }
          }
        }
      }

      &-items {
        letter-spacing: 0.03em;
        margin-bottom: 12px;
      }
    }

    &__content {
      @media screen and (min-width: $screen-lg) {
        width: 50%;
      }
    }

    @media screen and (min-width: $screen-lg) {
      flex-direction: row;
    }

    &__plan {
      width: 100%;
      position: relative;
      margin: 30px 0;

      &-poligon {
        width: 100%;
        position: relative;
        margin: 18px 0;
        padding-bottom: 76px;
        @media (min-width: $screen-mini) {
          width: 60%;
          margin: 30px 0;
        }
        @media (min-width: $screen-lg) {
          width: 100%;
        }
      }
      @media (min-width: $screen-lg) {
        width: 600px;
        margin-bottom: 0px;
      }

      &-image {
        width: 100%;
        object-fit: contain;
        min-height: 335px;
        max-height: 400px;

        @media screen and (min-width: $screen-lg) {
          max-height: 600px;
        }
      }
    }

    &__plan-promo {
      position: absolute;
      top: 5px;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 5px;
      width: 55px;
      height: 55px;
      background-color: #e14313;
      text-align: center;
      font-size: 24px;
      line-height: 1;
      color: var(--ms-apartment-tab-plan-promo-color, #fff);

      small {
        font-size: 12px;
        letter-spacing: -0.02em;
      }
    }

    &__alternative {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      @media screen and (min-width: $screen-sm) {
        justify-content: flex-start;
      }

      &-item {
        max-width: 100px;
        width: 100px;
        margin-right: 10px;

        // &:first-child {
        //   margin-right: 0;
        // }

        @media screen and (min-width: $screen-sm) {
          max-width: 120px;
          width: 120px;
          margin-right: 35px;
        }
      }
    }

    &__tour {
      position: absolute;
      top: 5px;
      right: 37px;
      padding: 2px 6px;
    }

    &__eye {
      position: absolute;
      top: 5px;
      right: 0;
    }

    &__fullscreen {
      position: absolute;
      bottom: 5px;
      right: 0;
    }
  }

  &__info,
  .apart-info {
    margin-left: 0;
    flex: 1;
    padding-top: 20px;

    @media screen and (min-width: $screen-lg) {
      margin-left: 100px;
    }

    &__bottom-button-group {
      display: flex;
      &--tradein {
        .apart-info__bottom-act2 {
          width: auto;
        }
      }
    }

    &__bottom-share {
      position: relative;
      margin-left: 16px;
    }
    &__bottom-share-container {
      display: none;
      position: absolute;
      top: calc(100% + 5px);
      right: 0;
      justify-content: end;
      width: 80px;
      background: #fff;
      padding: 10px;
      &.openned {
        display: flex;
      }
    }

    &__bottom-share-act2 {
      width: 40px;
      padding: 0;
      svg path {
        transition: all 300ms ease-out;
      }
      &:hover {
        svg path {
          fill: #fff;
        }
      }
    }

    &__wrap {
      display: flex;
      margin-bottom: 25px;
      padding: 0 0 20px;
      border-bottom: 1px solid #00000011;
    }
    &__border {
      margin-bottom: 20px;
      padding: 0 0 15px;
      border-bottom: 1px solid #00000011;

      @media screen and (min-width: $screen-sm) {
        margin-bottom: 25px;
        padding: 0 0 25px;
      }
    }

    &__footnote {
      margin-bottom: 0;
    }

    &__description {
      color: #18181b;
      opacity: 0.5;
      font-weight: normal;
      font-size: 10px;
      line-height: 132.5%;
      letter-spacing: 0.18em;
      @media screen and (min-width: $screen-sm) {
        font-size: 16px;
      }
      @media screen and (min-width: $screen-lg) {
        font-size: 14px;
      }
    }
    &__areas {
      &-title {
        font-family: $font-family-bebas;
        font-weight: 400;
        font-size: 24px;
        line-height: 98%;
        letter-spacing: 0.05em;
        // text-transform: uppercase;
        margin-bottom: 25px;

        @media screen and (min-width: $screen-mini) {
          font-size: 28px;
        }
      }

      &-list,
      .apart-areas {
        &__list {
          list-style-type: none;
          counter-reset: li;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 25px;
          padding: 20px 0 20px;
          border-bottom: 1px solid #00000011;

          &-item,
          .area-item {
            font-family: $font-family-bebas;
            font-size: 14px;
            line-height: 132.5%;
            letter-spacing: 0.18em;
            font-weight: 400;
            // text-transform: uppercase;
            color: #18181b;
            margin-bottom: 7px;
            width: 100%;
            display: flex;
            box-sizing: border-box;

            @media screen and (min-width: $screen-mini) {
              width: 50%;

              &:nth-child(odd) {
                padding-right: 25px;
              }

              &:nth-child(even) {
                padding-left: 25px;
              }
            }

            &__body {
              display: flex;
              justify-content: space-between;
              flex: 1;
              position: relative;

              &:after {
                border-bottom: 2px dotted #bdbdbd;
                content: "";
                display: block;
                overflow: hidden;
                height: 2px;
                width: 100%;
                position: absolute;
                bottom: 6px;
              }
            }

            &__number {
              color: #bdbdbd;
              &:after {
                content: "";
                color: #bdbdbd;
                margin-right: 10px;
                border-right: 1px solid;
                padding-right: 10px;
              }
            }

            &__key {
              color: #bdbdbd;
              background-color: #f4f4f4;
              z-index: 1;
            }

            &__value {
              background-color: #f4f4f4;
              z-index: 1;
              font-weight: 700;
            }
          }

          .items__shown {
            font-family: Rubik;
            font-weight: 300;
            font-size: 12px;
            letter-spacing: 0.03em;
            text-decoration-line: underline;
            text-transform: uppercase;
            cursor: pointer;

            &:hover {
              @media screen and (min-width: $screen-md) {
                text-decoration-line: none;
              }
            }

            @media screen and (min-width: $screen-mini) {
              display: none;
            }
          }
        }
      }
    }

    &__props,
    .apart-props {
      display: flex;
      justify-content: space-between;
      //margin-bottom: 25px;
      padding: 0 0 20px;
      border-bottom: 1px solid #00000011;

      &__item {
        &--orange {
          color: #ff5722;

          .apart-props {
            &__item-label,
            &__item-value {
              color: inherit;
            }

            &__item-label {
              opacity: 1;
            }
          }
        }

        &-num_floor {
          color: black;
          font-size: 10px;
          margin-top: 1px;
          @media screen and (min-width: $screen-sm) {
            font-size: 14px;
          }
        }
        &-label {
          display: flex;
          font-family: Bebas Neue;
          font-weight: 400;
          font-size: 10px;
          line-height: 132.5%;
          letter-spacing: 0.18em;
          // text-transform: uppercase;
          color: #18181b;
          opacity: 0.5;
          margin-bottom: 5px;

          @media screen and (min-width: $screen-mini) {
            font-size: 14px;
          }
          img {
            height: 13px;
            @media screen and (min-width: $screen-sm) {
              height: 16px;
            }
          }
        }

        &-icon {
          width: 16px;
          margin-right: 5px;

          @media (min-width: $screen-xxs) {
            margin-right: 10px;
          }
        }

        &-value {
          font-family: Bebas Neue;
          font-size: 18px;
          line-height: 98%;
          letter-spacing: 0.05em;
          color: #18181b;
          &--small {
            font-size: 57%;
            span {
              font-size: 80%;
            }
          }

          @media screen and (min-width: $screen-mini) {
            font-size: 24px;
          }
        }
      }
    }

    &__cost-wrapper {
      display: flex;
      align-items: center;
    }
    &__cost {

      &-now {
        font-family: $font-family-rubik;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 98%;
        // text-transform: uppercase;
        color: #18181b;
        opacity: 0.6;
        margin-right: 10px;

        @media screen and (min-width: $screen-mini) {
          font-size: 22px;
          margin-right: 25px;
        }
      }

      &-now_min {
        display: block;
        font-family: $font-family-rubik;
        font-style: normal;
        font-weight: 500;
        font-size: 28px;
        line-height: 98%;
        // text-transform: uppercase;
        color: #18181b;
        margin-right: 10px;
        margin-bottom: 5px;

        @media screen and (min-width: $screen-mini) {
          font-size: 28px;
          margin-right: 25px;
        }
      }

      &-old {
        font-family: $font-family-rubik;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 132.5%;
        color: #18181B;
        position: relative;
        display: inline-block;
        &::after {
          width: 100%;
          background: #E14313;
          content: '';
          height: 2px;
          position: absolute;
          top: 48%;
          left: 0;
        }
      }
    }

    &__bottom {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media screen and (min-width: $screen-mini) {
        flex-direction: row;
      }

      @media screen and (min-width: $screen-lg) {
        flex-direction: column;
      }

      &--column {
        margin-top: 12px;
        flex-direction: column;
        .apart-info__bottom-buttons {
          display: block;
        }
      }

      &-act1 {
        margin-right: 15px;
      }

      &-act1 {
        width: 100%;
        margin-bottom: 10px;

        @media screen and (min-width: 425px) {
          width: auto;
          margin-bottom: 0;
        }
      }

      &-act2 {
        width: calc(100% - 56px);

        @media screen and (min-width: 425px) {
          width: auto;
        }
      }

      &-action {
        display: flex;
        margin-top: 15px;

        @media screen and (min-width: $screen-mini) {
          margin-top: 0;
        }

        @media screen and (min-width: $screen-lg) {
          margin-top: 15px;
        }

        button {
          margin-right: 15px;
        }
      }
      &-buttons {
        display: flex;
        @media screen and (max-width: 424px) {
          flex-direction: column;
        }
        .ui-button {
          height: 40px;
        }
      }
      &-booked {
        color: #e14313;
        margin-bottom: 0;
        font-size: 16px;
        letter-spacing: 0.18em;
        line-height: 132.5%;
        margin-bottom: 28px;

        @media screen and (min-width: $screen-sm + 1px) {
          margin-bottom: 40px;
        }
        @media screen and (min-width: $screen-sm) {
          font-size: 24px;
          margin-top: 0;
        }
      }
    }
    &__special-mortgage {
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 132.5%;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      padding-top: 10px;
      display: inline-block;
      color: #E14313;
      width: 100%;
    }
  }
}
</style>
